<template>
  <div class="row">
    <div class="col-12">
      <MyConsultations />
    </div>
    <div class="col-12 mt-2">
      <AllPendingProducts />
    </div>
  </div>
</template>
<script>
import MyConsultations from '@views/admin/reservations/viewforuser';
import AllPendingProducts from '@views/admin/products/viewpending';

export default {
  name: 'DoctorDashboard',
  components: {
    MyConsultations,
    AllPendingProducts
  },
  data() {
    return {
      ready: false
    };
  }
};
</script>
<style scoped>

</style>
